<template>
  <v-container class="subheading">
    <v-layout text-xs-center wrap>
      <v-flex md4>
        <img
          style="padding: 0px"
          :src="require('@/assets/mypic.jpg')"
          alt="Avatar"
          width="300"
          height="250"
        >
      </v-flex>
      <v-flex md7 text-xs-left>
        Hi there, I am Diptanshu Kakwani. I am currently pursuing MS in Computer Science at
        <a
          href="https://www.cse.iitm.ac.in/"
          target="_blank"
        >IIT Madras</a>.
        I work in
        <a href="http://pace.cse.iitm.ac.in/" target="_blank">PACE Lab</a>, and Prof
        <a href="http://www.cse.iitm.ac.in/~rupesh/" target="_blank">Rupesh Nasre</a> is my faculty advisor.
        I have been fortunate enough to experience work in both industry and academia. Before I joined IIT Madras,
        I worked at Morgan Stanley as Technology Analyst and before that at Indian Institute of Science as research intern,
        under the guidance of Prof <a href="http://cds.iisc.ac.in/faculty/simmhan/" target="_blank">Yogesh Simmhan</a>.
        You can find my resume at
        <a
          href="http://linkedin.com/in/dipkakwani/"
          target="_blank"
        >LinkedIn</a>.
        <br>
        <br>Apart from computers, I enjoy playing sports and reading books.
        If you have some common interests or want to chat, feel free to drop a mail at dipkakwani at gmail dot com
        or connect with me through social media accounts given in the
        <router-link to="/contact">contact page</router-link>.
      </v-flex>
      <v-spacer></v-spacer>
</v-layout>
<v-layout wrap>
  <v-timeline>
    <v-timeline-item
      v-for="(year, i) in years"
      :key="i"
      :color="year.color"
      :right=true
      small
    >
      <template v-slot:opposite>
        <span
          :class="`headline font-weight-bold ${year.color}--text`"
          v-text="year.year"
        ></span>
      </template>
      <div class="py-4">
        <h2 :class="`headline font-weight-light mb-4 ${year.color}--text`">{{year.head}}</h2>
        <div>
          {{year.body}}
        </div>
      </div>
    </v-timeline-item>
  </v-timeline>
    </v-layout>
  </v-container>

</template>

<script>
export default {
  name: "About",
  data: function() {
    return {
      years: [
        {
          color: 'cyan',
          year: '2018',
          head: 'IIT Madras',
          body: 'MS Research Scholar',
        },
        {
          color: 'green',
          year: '2017',
          head: 'Morgan Stanley',
          body: 'Technology Associate',
        },
        {
          color: 'pink',
          year: '2016',
          head: 'Indian Institute of Science (IISc)',
          body: 'Research Intern',
        },
        {
          color: 'amber',
          year: '2013',
          head: 'Ramaiah Insititue of Technology',
          body: 'Bachelor of Engineering',
        },
      ],
    };
  }
};
</script>
<style>
img {
  border-radius: 10%;
}
</style>
